import {gsap} from 'gsap'
import * as React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {makeEditable, unwrapAllNodeResolvers} from '@/common/utils'
import Author from '@/components/RichText/Quote/Author/Author'

const Quote = ({content, authorName, authorPicture, _editable}) => {
  const sectionRef = React.useRef()

  React.useEffect(() => {
    const container = sectionRef.current

    if (container) {
      const context = gsap.context(() => {
        gsap.fromTo(
          'path',
          {drawSVG: '0%'},
          {
            drawSVG: '100%',
            scrollTrigger: {
              trigger: container,
              start: 'center bottom',
            },
          }
        )
      }, container)

      return () => context.revert()
    }
  })

  return (
    <section
      ref={sectionRef}
      {...makeEditable(_editable)}
      className='relative my-10 flex w-full flex-col justify-center rounded-2xl bg-yellow-300 py-10 px-14'
    >
      <span className='heading-xs-satoshi [&>b]:heading-xs-millik text-center'>
        {render(content, {nodeResolvers: unwrapAllNodeResolvers})}
      </span>

      {authorName && (
        <div className='mt-6 flex justify-center'>
          <Author name={authorName} picture={authorPicture} />
        </div>
      )}

      <Doodle
        aria-hidden
        className='absolute -right-9 z-20 hidden md:top-1/3 md:block lg:top-1/4'
      />
    </section>
  )
}

const Doodle = (props) => (
  <svg
    width='179'
    height='248'
    viewBox='0 0 179 248'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_603_15461)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M126.607 153.768C126.243 154.184 125.612 154.226 125.196 153.863L92.9056 125.615C92.49 125.251 92.4478 124.619 92.8114 124.203C93.1751 123.788 93.8068 123.746 94.2225 124.109L126.513 152.357C126.928 152.721 126.971 153.353 126.607 153.768ZM72.6589 208.272C72.223 208.611 71.5947 208.532 71.2556 208.096C70.277 206.839 69.23 204.482 68.1844 201.637C67.123 198.748 66.0176 195.224 64.9517 191.528C62.8192 184.134 60.8294 175.996 59.6481 170.757C59.5267 170.218 59.8649 169.683 60.4037 169.562C60.9424 169.44 61.4777 169.778 61.5991 170.317C62.7744 175.529 64.7547 183.627 66.8734 190.974C67.933 194.648 69.0235 198.122 70.0617 200.947C71.1157 203.815 72.0721 205.889 72.834 206.868C73.1732 207.304 73.0948 207.933 72.6589 208.272ZM25.6434 166.649C25.87 166.146 25.6454 165.554 25.1417 165.327C24.6381 165.101 24.0461 165.325 23.8195 165.829L10.9851 194.356C10.7585 194.86 10.9831 195.452 11.4867 195.678C11.9904 195.905 12.5824 195.68 12.809 195.177L25.6434 166.649ZM149.388 29.0016C149.326 29.5504 148.83 29.9445 148.281 29.882C148.195 29.8722 147.938 29.8872 147.447 30.0069C146.987 30.1192 146.411 30.2999 145.74 30.5411C144.4 31.0228 142.745 31.7209 140.984 32.517C137.466 34.1076 133.589 36.0598 131.094 37.3721C130.605 37.6292 130.001 37.4414 129.743 36.9526C129.486 36.4638 129.674 35.8591 130.163 35.602C132.68 34.2777 136.595 32.3064 140.16 30.6946C141.941 29.8895 143.651 29.1667 145.064 28.659C145.769 28.4055 146.417 28.1993 146.973 28.0639C147.498 27.9359 148.048 27.8425 148.508 27.8949C149.056 27.9574 149.451 28.4529 149.388 29.0016ZM152.029 85.7825C152.581 85.783 153.029 85.3356 153.03 84.7833C153.03 84.2311 152.583 83.783 152.031 83.7825L120.087 83.7553C119.535 83.7548 119.087 84.2021 119.086 84.7544C119.086 85.3067 119.533 85.7548 120.085 85.7553L152.029 85.7825Z'
        fill='#7F6AFF'
      />
    </g>
    <defs>
      <clipPath id='clip0_603_15461'>
        <rect
          width='91.9344'
          height='230.522'
          fill='white'
          transform='translate(83.8398 247.946) rotate(-155.777)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Quote
